/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import { ucwords } from '../../../../helper';
import * as actions from '../../../../actions';
import * as c from '../../../../constant';

function UpdateBusinessActivity({
  formData,
  getBusinessNaturesList,
  businessNaturesList,
  getBusinessLinesList,
  businessLinesList,
  getNecessaryFieldsList,
  necessaryFieldsList,
  setFormData,
  closeModal,
  handleOnUpdate,
  businessActivityInfo,
  viewUpdateForm,
}) {
  const [formDataMultiplier, setFormDataMultiplier] = useState({});
  const [multiplierData, setMultiplierData] = useState({});

  const validateMultiplier = Object.keys(formDataMultiplier)
    .map(item => {
      return { [item]: 'required' };
    })
    .values();

  const setValidateMultiplier = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const value of validateMultiplier) {
      setMultiplierData(prevData => ({
        ...prevData,
        ...value,
      }));
    }
  };

  const validateFormMultiplier = useFormValidator(
    formDataMultiplier,
    multiplierData
  );

  useEffect(() => {
    validateFormMultiplier.onSetObjectRules(multiplierData);
  }, [multiplierData, formDataMultiplier]);

  useEffect(() => {
    setValidateMultiplier();
  }, [formDataMultiplier, _.get(formData, 'business_line_id')]);

  useEffect(() => {
    validateFormMultiplier.validate();
  }, [multiplierData, formDataMultiplier]);

  const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, '');

  const validateForm = useFormValidator(formData, {
    business_nature_id: 'required',
    business_line_id: 'required',
    // capital_amount: 'required',
    // gross_amount: 'required',
  });

  useEffect(() => {
    getBusinessNaturesList();
    setFormData({
      business_nature_id: '',
      business_line_id: '',
      capital_amount: '',
      gross_amount: '',
      line_of_business: '',
      business_nature_name: '',
      business_line_name: '',
      override_amount: 0,
      details: {},
    });
  }, []);

  const handleNatureDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      business_nature_name: e.label,
      business_line_id: '',
    });

    getBusinessLinesList({ business_nature_id: e.value });
  };

  const selectBusinessNatureId = businessNaturesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleLineDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      line_of_business: e.label,
      business_line_name: e.label,
    });

    // getNecessaryFieldsList({ business_line_id: e.value });
    getNecessaryFieldsList({ business_line_id: e.value }, ({data}) => {
      if(_.isEmpty(formDataMultiplier)) {
        setFormDataMultiplier({
          ...(data.map((item) => item.multiplier)).reduce((ac, label) => ({...ac,[label]:''}),{}),
        })
      } else {
        setFormDataMultiplier({
          ...formDataMultiplier,
        })
      }
    });
  };

  const onChangeMultiplier = e => {
    setFormDataMultiplier({
      ...formDataMultiplier,
      [e.target.name]: addCommas(removeNonNumeric(e.target.value)),
    });

    setFormData({
      ...formData,
      [e.target.name]: addCommas(removeNonNumeric(e.target.value)),
    });
  };

  const onChangeMultiplierSelect = key => e => {
    setFormDataMultiplier({
      ...formDataMultiplier,
      [key]: e ? e.value : '',
    });
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  }

  const selectBusinessLineId = businessLinesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  // const handleOfficeTypeDropDownChange = key => e => {
  //   setFormData({
  //     ...formData,
  //     [key]: e ? e.value : '',
  //   });
  // };

  const selectOptions = list => {
    const newList = [];

    list.map(data => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, x => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  // const handleOnChange = key => e => {
  //   setFormData({
  //     ...formData,
  //     [key]: addCommas(removeNonNumeric(e.target.value)),
  //   });
  // };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  useEffect(() => {
    if (!_.isEmpty(businessActivityInfo)) {
      let keyValues = [];
      keyValues = Object.entries(
        _.get(businessActivityInfo, 'details') || ''
      ).map(([key, value]) => ({
        [key]: value.toString() || '',
      }));

      let finalObject = {};
      const badCallback = (a, i) => Object.assign(a, i);
      finalObject = keyValues.reduce(badCallback, {});

      setFormData({
        ...formData,
        ...finalObject,
        business_nature_id: _.get(businessActivityInfo, 'business_nature_id'),
        business_line_id: _.get(businessActivityInfo, 'business_line_id'),
        capital_amount: _.get(businessActivityInfo, 'capital_amount'),
        gross_amount: _.get(businessActivityInfo, 'gross_amount'),
        id: _.get(businessActivityInfo, 'id'),
        activity_id: _.get(businessActivityInfo, 'activity_id'),
        initial_data: _.get(businessActivityInfo, 'initial_data'),
        business_line_name: _.get(businessActivityInfo, 'business_line_name'),
        business_nature_name: _.get(
          businessActivityInfo,
          'business_nature_name'
        ),
      });

      getBusinessLinesList({
        business_nature_id: _.get(businessActivityInfo, 'business_nature_id'),
      });
      getNecessaryFieldsList({
        business_line_id: _.get(businessActivityInfo, 'business_line_id'),
      });
      setFormDataMultiplier({
        ...finalObject,
      });
    }
  }, []);

  useEffect(() => {
    setFormDataMultiplier({})
    setMultiplierData({})
  }, [_.get(formData, 'business_nature_id')])

  const findBusinessNatureValue =
    selectBusinessNatureId.find(
      item => +_.get(formData, 'business_nature_id') === +item.id
    ) || '';

  const findBusinessLineValue =
    selectBusinessLineId.find(
      item => +_.get(formData, 'business_line_id') === +item.id
    ) || '';

  return (
    <div className="col-12">
      <div className="row">
        <div className="col-12 form-group">
          <div className="row p-2">
            <div className="col-12 my-2">
              <label className="text-primary font-weight-bold">
                Requested Line of Business : &nbsp;{' '}
                {_.get(formData, 'initial_data.line_of_business') || '--'}
              </label>
            </div>
          </div>

          <div className="col-12 form-group">
            <label className="form-label">
              Business Nature:
              {validateForm.renderMessage('business_nature_id')}
            </label>
            <Select
              options={selectBusinessNatureId}
              placeholder="Select Business Nature"
              onChange={handleNatureDropDownChange('business_nature_id')}
              value={findBusinessNatureValue}
              isDisabled={viewUpdateForm === false}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Business Line:
              {validateForm.renderMessage('business_line_id')}
            </label>
            <Select
              options={selectBusinessLineId}
              placeholder="Select Business Line"
              onChange={handleLineDropDownChange('business_line_id')}
              value={findBusinessLineValue}
              isDisabled={viewUpdateForm === false}
            />
          </div>
          <div className="col-12 form-group">
            {_.get(formData, 'business_line_id') !== '' && necessaryFieldsList.map((item, i) => (
              <div key={`BusinessLine ${i + 1}`}>
                <div>
                  {_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}
                        {validateFormMultiplier.renderMessage(
                          `${item.multiplier}`
                        )}
                      </label>
                      <Select
                        onChange={onChangeMultiplierSelect(
                          _.get(item, 'multiplier')
                        )}
                        options={selectOptions(_.get(item, 'options'))}
                        value={
                          selectOptions(_.get(item, 'options')).find(
                            x =>
                              _.get(formData, _.get(item, 'multiplier')) ===
                              _.get(x, 'value')
                          ) || ''
                        }
                        isDisabled={viewUpdateForm === false}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group">
                  {!_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(item.multiplier.replace(/_/g, ' '))}:
                        {validateFormMultiplier.renderMessage(
                          `${item.multiplier}`
                        )}
                      </label>
                      <input
                        name={item.multiplier}
                        onChange={onChangeMultiplier}
                        className="form-control"
                        value={addCommas(
                          removeNonNumeric(
                            _.get(
                              formData,
                              _.get(item, 'multiplier')
                            ) || ''
                          )
                        )}
                      />
                      {/* <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name={_.get(item, 'label')}
                        id={_.get(item, 'label')}
                        onChange={handleOnChange(_.get(item, 'multiplier'))}
                        value={_.get(formData, _.get(item, 'multiplier')) || ''}
                        required
                        disabled={viewUpdateForm === false}
                      /> */}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {viewUpdateForm === true && (
        <div className="d-flex justify-content-end pb-3">
          <button
            disabled={
              !validateForm.response.is_passed ||
              !validateFormMultiplier.response.is_passed
            }
            type="button"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            onClick={handleOnUpdate(formData)}
          >
            <span className="font-weight-bold">Update</span>
          </button>
          <button
            type="button"
            onClick={() => closeModal()}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      )}
    </div>
  );
}

UpdateBusinessActivity.defaultProps = {
  businessActivityInfo: {},
  viewUpdateForm: false,
};

UpdateBusinessActivity.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  getBusinessNaturesList: PropTypes.instanceOf(Function).isRequired,
  businessNaturesList: PropTypes.instanceOf(Array).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,
  handleOnUpdate: PropTypes.instanceOf(Function).isRequired,
  businessActivityInfo: PropTypes.instanceOf(Object),
  viewUpdateForm: PropTypes.bool,
};

const mapStateToProps = ({ api }) => ({
  businessNaturesList: _.get(api, `${c.GET_BUSINESS_NATURES_LIST}.list`) || [],
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateBusinessActivity);
